// ─── MSP Belt Standards ────────────────────────────────────────────────────────
export const BELT_LEVELS = ['yellow', 'green', 'blue', 'purple', 'brown', 'black'];
export const BELT_COLORS = {
    yellow: '#f1c40f',
    green: '#2ecc71',
    blue: '#3498db',
    purple: '#9b59b6',
    brown: '#8B4513',
    black: '#ecf0f1',
};

export const DRILLS = [
    {
        id: '3x2',
        name: '3×2 Drill',
        subtitle: '3 yards',
        description: 'Draw and fire 3 body shots (A-zone) then 2 head shots',
        yardage: 3,
        parTimes: {
            yellow: 4.0, green: 3.5,
            blue: 3.0, purple: 2.5, brown: 2.15, black: 2.0
        },
        shots: [
            { zone: 'body', index: 0 },
            { zone: 'body', index: 1 },
            { zone: 'body', index: 2 },
            { zone: 'head', index: 0 },
            { zone: 'head', index: 1 },
        ],
    },
    {
        id: '7yard',
        name: '7-Yard Draw',
        subtitle: '7 yards',
        description: 'Draw and fire 1 shot center mass (A-zone)',
        yardage: 7,
        parTimes: {
            yellow: 2.0, green: 1.75,
            blue: 1.5, purple: 1.3, brown: 1.1, black: 1.0
        },
        shots: [{ zone: 'body', index: 0 }],
    },
    {
        id: 'bill',
        name: 'Bill Drill',
        subtitle: '7 yards',
        description: 'Draw and fire 6 shots center mass (A-zone)',
        yardage: 7,
        parTimes: {
            yellow: 4.0, green: 3.5,
            blue: 3.0, purple: 2.5, brown: 2.15, black: 2.0
        },
        shots: [
            { zone: 'body', index: 0 },
            { zone: 'body', index: 1 },
            { zone: 'body', index: 2 },
            { zone: 'body', index: 3 },
            { zone: 'body', index: 4 },
            { zone: 'body', index: 5 },
        ],
    },
    {
        id: '25yard',
        name: '25-Yard Shot',
        subtitle: '25 yards',
        description: 'Draw and fire 1 shot center mass (A-zone)',
        yardage: 25,
        parTimes: {
            yellow: 2.75, green: 2.5,
            blue: 2.25, purple: 2.0, brown: 1.65, black: 1.5
        },
        shots: [{ zone: 'body', index: 0 }],
    },
];

// Full test: run all 4 drills in sequence. Belt only if ALL pass at same level.
export const FULL_DRILL = {
    id: 'full',
    name: 'MSP Full Test',
    subtitle: 'All 4 drills',
    description: 'Run all four MSP standards back-to-back. You must pass every drill at the same belt level to earn it.',
    isFullTest: true,
};

export const ADDITIONAL_DRILLS = [
    {
        id: '3y-reload',
        name: '3-Yard Reload',
        subtitle: '3 yards',
        description: 'Draw, fire 1 shot center mass, reload, fire 1 shot center mass (A-zone).',
        yardage: 3,
        parTimes: {
            yellow: 4.5, green: 3.5,
            blue: 3.0, purple: 2.75, brown: 2.5, black: 2.2
        },
        shots: [
            { zone: 'body', index: 0 },
            { zone: 'body', index: 1 }
        ],
    },
    {
        id: 'depth-transitions',
        name: 'Depth Transitions',
        subtitle: '3, 7, 15, and 25 yards',
        description: 'Draw and fire 1 shot each on targets at 3, 7, 15, and 25 yards (A-zone).',
        yardage: 25, // default, but overridden
        parTimes: {
            yellow: 6.0, green: 5.0,
            blue: 4.0, purple: 3.5, brown: 3.0, black: 2.5
        },
        shots: [
            { zone: 'body', index: 0, yardage: 3, screenX: 0.15 },
            { zone: 'body', index: 1, yardage: 7, screenX: 0.38 },
            { zone: 'body', index: 2, yardage: 15, screenX: 0.61 },
            { zone: 'body', index: 3, yardage: 25, screenX: 0.84 }
        ],
    },
    {
        id: 'texas-star',
        name: 'Texas Star',
        subtitle: '10 yards, Moving',
        description: 'Shoot all 5 plates. The star will rotate as plates are knocked off.',
        yardage: 10,
        isTexasStar: true,
        parTimes: {
            yellow: 7.5, green: 5.5,
            blue: 4.0, purple: 3.5, brown: 3.0, black: 2.5
        },
        shots: Array.from({ length: 5 }, (_, i) => ({ zone: 'plate', index: i })),
    },
    {
        id: '1-1-2-1-1-drill',
        name: '1-1-2-1-1 Transitions',
        subtitle: '7 yards, L-R-L',
        description: 'Shoot far left, middle, right (twice), middle, and left on three 7-yard A-zones.',
        yardage: 7,
        ordered: true,
        parTimes: {
            yellow: 6.5, green: 5.5,
            blue: 4.5, purple: 3.5, brown: 2.8, black: 2.3
        },
        shots: [
            { zone: 'body', index: 0, screenX: 0.2 }, // Left (1)
            { zone: 'body', index: 1, screenX: 0.5 }, // Middle (1)
            { zone: 'body', index: 2, screenX: 0.8 }, // Right (1)
            { zone: 'body', index: 3, screenX: 0.8 }, // Right (2)
            { zone: 'body', index: 4, screenX: 0.5 }, // Middle (2)
            { zone: 'body', index: 5, screenX: 0.2 }  // Left (2)
        ],
    }
];

export const CLICK6_DRILLS = [
    {
        id: 'click-6-random',
        name: 'Click 6: Random',
        subtitle: '10 yards, Random',
        description: 'Shoot 6 randomly placed 8-inch steel plates.',
        yardage: 10,
        isClick6: true,
        click6Mode: 'random',
        parTimes: {
            yellow: 7.0, green: 5.5,
            blue: 4.5, purple: 4.0, brown: 3.5, black: 3.0
        },
        shots: Array.from({ length: 6 }, (_, i) => ({ zone: 'plate', index: i })),
    },
    {
        id: 'click-6-grid',
        name: 'Click 6: Grid',
        subtitle: '10 yards, Row',
        description: 'Shoot 6 steel plates arranged in a horizontal line.',
        yardage: 10,
        isClick6: true,
        click6Mode: 'grid',
        parTimes: {
            yellow: 6.5, green: 5.0,
            blue: 4.0, purple: 3.5, brown: 3.0, black: 2.5
        },
        shots: Array.from({ length: 6 }, (_, i) => ({ zone: 'plate', index: i })),
    },
    {
        id: 'click-6-w',
        name: 'Click 6: W Pattern',
        subtitle: '10 yards, W Shape',
        description: 'Shoot 6 steel plates arranged in a W-pattern.',
        yardage: 10,
        isClick6: true,
        click6Mode: 'w_pattern',
        parTimes: {
            yellow: 7.0, green: 5.5,
            blue: 4.5, purple: 4.0, brown: 3.5, black: 3.0
        },
        shots: Array.from({ length: 6 }, (_, i) => ({ zone: 'plate', index: i })),
    }
];

export const ALL_DRILLS = [...DRILLS, FULL_DRILL, ...ADDITIONAL_DRILLS, ...CLICK6_DRILLS];

// ─── Belt Eval ────────────────────────────────────────────────────────────────
export function evaluateBelt(drill, timeSeconds, parTimes) {
    if (timeSeconds === null) return null;
    const p = parTimes ?? drill.parTimes;
    if (timeSeconds <= p.black) return 'black';
    if (timeSeconds <= p.brown) return 'brown';
    if (timeSeconds <= p.purple) return 'purple';
    if (timeSeconds <= p.blue) return 'blue';
    if (timeSeconds <= p.green) return 'green';
    if (timeSeconds <= p.yellow) return 'yellow';
    return 'miss';
}

// Full test: highest belt where ALL 4 drills are within par.
export function evaluateFullBelt(times, drills, effectiveParFn) {
    for (const belt of [...BELT_LEVELS].reverse()) {
        const allPassed = drills.every((d, i) => times[i] != null && times[i] <= effectiveParFn(d)[belt]);
        if (allPassed) return belt;
    }
    return 'miss';
}
